import { Link, useForm, usePage } from "@inertiajs/react";
import type { FormEvent } from "react";
import Layout from "@/components/Layout";
import type { SharedProps } from "@/types";

type NewProps = {
  form: {
    start_url: string;
  };
};

export default function New({ form }: NewProps) {
  const { query_parameters } = usePage<SharedProps>().props;
  const { data, errors, processing, setData, post } = useForm({
    start_url: form.start_url || query_parameters?.url || "",
  });

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    post("/audits");
  }

  return (
    <Layout title="New audit">
      <div className="mx-auto max-w-2xl">
        <div className="mb-6">
          <h1 className="mb-1 text-2xl font-semibold">Run page audit</h1>
          <p className="text-gray-500">
            Enter a page URL. We use the same single-page auditor flow as domain page audits. If the hostname matches a
            domain on your account, findings link to that domain.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="card">
          <div className="card-body space-y-6">
            <div>
              <label htmlFor="start_url" className="mb-1.5 block text-sm font-medium text-gray-700">
                Page URL
              </label>
              <input
                id="start_url"
                type="text"
                className="input"
                placeholder="https://example.com/pricing"
                value={data.start_url}
                onChange={(event) => setData("start_url", event.target.value)}
                autoFocus
              />
              {errors.start_url && <p className="mt-1.5 text-sm text-error">{errors.start_url}</p>}
            </div>

            <div className="flex flex-col-reverse justify-between gap-3 border-t border-gray-200 pt-6 sm:flex-row">
              <Link href="/audits" className="btn">
                Cancel
              </Link>
              <button type="submit" className="btn btn-primary" disabled={processing || !data.start_url.trim()}>
                {processing ? "Starting..." : "Start audit"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </Layout>
  );
}
